var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tick text-block"},[_c('div',{staticClass:"tick-icon"}),_c('h3',{staticClass:"tick-text",domProps:{"innerHTML":_vm._s(_vm.$nl2br(_vm.item.content))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }